import { getCloudFlareImgVariant } from 'components/helpers/withSizes'
import Link from 'next/link'
import { useRouter } from 'next/router'
import * as R from 'ramda'
import Feed from 'routes/Home/components/Feed'
import styled, { css } from 'styled-components'

import { doLoadFeed } from '../modules/datasource'

const StyledFeed = styled(Feed)`
  padding: 0 !important;

  .MuiTabs-root {
    background-color: ${({ theme }) => theme.colors.white};
    margin-bottom: 0 !important;
  }

  ${({ theme }) => theme.media.phone} {
    padding: 0 16px 56px !important;
    flex-direction: column;
  }
`

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  padding: 0 152px;
  max-width: 1440px;
  margin: 0 auto;
  width: 100%;
  flex: 1;
  ${({ theme }) => theme.media.tablet} {
    padding: 0 32px;
  }
  ${({ theme }) => theme.media.phone} {
    padding: 0;
  }
`

export const Content = styled.div`
  flex: 1;
`

export const ImgProfile = styled.div`
  height: 100%;
  width: 100%;
  ${({ src }) =>
    src &&
    css`
      background-image: ${`url(${src})`};
      background-size: cover;
      background-position: center;
    `};
`

const StyledOther = styled.div`
  display: flex;
  cursor: pointer;
  width: fit-content;
  & + & {
    margin-top: 16px;
  }
`
const AuthorImg = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryL};
  border-radius: 50%;
  height: 30px;
  width: 30px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`
const OtherImg = styled(AuthorImg)`
  height: 48px;
  width: 48px;
  min-height: 48px;
  min-width: 48px;
  text-transform: uppercase;
`
const OtherDesc = styled.div`
  display: flex;
  flex-direction: column;
`
const OtherSingleLine = styled.div`
  color: ${({ theme }) => theme.colors.grey};
  ${({ theme }) => theme.font.body2}
`
const StyledImg = styled.img`
  height: 100%;
  width: 100%;
  object-position: center;
  object-fit: cover;
`

const Person = ({ data }) => {
  const { username, profileImage, singleLineStatement } = data
  const authorPath = `/p/${username}`
  return !username ? null : (
    <Link href={authorPath} passHref>
      <StyledOther>
        <OtherImg>
          {profileImage ? (
            <StyledImg
              src={getCloudFlareImgVariant(profileImage, {
                default: 'profileSmall',
              })}
            />
          ) : (
            R.head(username || '')
          )}
        </OtherImg>
        <OtherDesc>
          {username}
          <OtherSingleLine>{singleLineStatement}</OtherSingleLine>
        </OtherDesc>
      </StyledOther>
    </Link>
  )
}

export const ArticleTabs = ({ username, onPostOpen }) => {
  const router = useRouter()
  const { tab = 'published' } = router.query

  const tabs = [
    { label: 'Articles', value: 'published', componentType: 'Article' },
    {
      label: 'Posts',
      value: 'posts',
      componentType: 'Post',
      emptyMessage: 'This user has not posted anything yet.',
      config: {
        customPath: `/p/${username}`,
        commentsStyle: { background: 'transparent' },
      },
    },
    { label: 'Questions', value: 'questions', componentType: 'Question' },
    {
      label: 'Following',
      value: 'following',
      component: Person,
      disableDivider: true,
    },
    { label: 'Followers', value: 'followers', component: Person },
  ]

  const crrTab = R.any(R.propEq(tab, 'value'), tabs) ? tab : 'published'

  const changeTab = tab => {
    window?.scroll(0, 0)
    router.push(`/p/${username}?tab=${tab}`, undefined, {
      shallow: true,
    })
  }

  const changePage = page => {
    window?.scroll(0, 0)
    router.push(`/p/${username}?tab=${crrTab}&page=${page}`, undefined, {
      shallow: true,
    })
  }

  const customLoad = async ({ type, page, accessToken }) => {
    return await doLoadFeed({ type, page, username, accessToken })
  }

  return (
    <StyledFeed
      customTabs={tabs || []}
      onChangeTab={changeTab}
      onChangePage={changePage}
      onLoadFeed={customLoad}
      disableAskButton
      defaultTab="published"
      onPostOpen={onPostOpen}
      hideSidebar
    />
  )
}
